import React from 'react'
import { Linking } from 'react-native'
import { useDispatch, useSelector } from 'APP/Hooks/redux'
import { selectActiveToast } from 'APP/Store/Toast/selectors'
import { toastActions } from 'APP/Store/Toast'
import Toast from './index'
import { navigationRef } from 'APP/Nav'
import { logger } from 'APP/Lib/Datadog'

export const ToastContainer: React.FC = () => {
  const dispatch = useDispatch()
  const activeToast = useSelector(selectActiveToast)

  const handleDismiss = (id: string) => {
    dispatch(toastActions.hideToast(id))
  }

  const handleLinkPress = async (url: string, isExternal: boolean) => {
    try {
      if (isExternal) {
        const canOpen = await Linking.canOpenURL(url)
        if (canOpen) {
          await Linking.openURL(url)
        } else {
          logger.error('External URL cannot be opened', { url })
        }
      } else {
        const [screen, search] = url.split('?')
        const params = search ? Object.fromEntries(new URLSearchParams(search)) : undefined

        const navigate =
          (navigationRef.navigate as unknown as (name: string, params?: object) => void) ?? null
        navigate?.(screen, params)
      }
    } catch (e) {
      logger.error('Error opening link', { url, isExternal }, e)
    }
  }

  if (!activeToast) {
    return null
  }

  return (
    <Toast
      key={activeToast.id}
      data={activeToast}
      onDismiss={handleDismiss}
      onLinkPress={handleLinkPress}
    />
  )
}

export default ToastContainer
